import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Typography, CircularProgress } from '@material-ui/core'
import DonutChart from '../charts/DonutChart'
import Cookies from 'js-cookie'
import AskReport from '../AskReport'

const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/"

const styles = theme => ({
  root: {
    width: '100%'
  },
  pie: {
    paddingTop: 40,
  },
  data: {
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'space-evenly'
  },
  divider: {
    opacity: 0.4,
  },
  stats: {
    fontWeight: 'bold',
    color: '#626262',
    [theme.breakpoints.up('xl')]: {
      fontSize: 16
    }
  },
  statsDark: {
    fontWeight: 'bold',
    color: '#fff',
    [theme.breakpoints.up('xl')]: {
      fontSize: 16
    }
  },
  loader: {
    marginLeft: '45%',
    marginTop: '30%',
  },
  standIn: {
    width: '100%',
    [theme.breakpoints.up('xl')]: {
      marginTop: '-50px',
      height: '35%',
      width: '85%'
    },
    [theme.breakpoints.down('lg')]: {
      width: '120%',
      marginTop: '-35px'
    }
  },
  unavailable: {
    position: 'absolute',
    textAlign: 'center',
    marginTop: '100px'
  }
})

class TentpoleMod extends Component {
  _isMounted = false

  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      tentpoleRoi: [],
    }
  }

  componentDidMount() {
    this._isMounted = true

    fetch(`${base_url}/tentpoleROI`,{
      method: 'GET',
      headers: {
        'token': Cookies.get('token')
      },
    })
    .then(response => response.json())
    .then(data => {
      if(this._isMounted && data) {
        console.log(data)

        this.setState({
          isLoading: false,
          tentpoleRoi: data.map(item => item.Data_Extended[0]),
        })
      } else {
        this.setState({
          isLoading: false,
          tentpoleRoi: []
        })
      }
    })
    .catch(error => {
      console.log(error)
    })
  }

  render() {
    const { classes } = this.props
    const incSales = []
    const incResponses = []
    const sales = []
    const responses = []
    const spend = []
    const mailed = []

    for(let i = 0; i < this.state.tentpoleRoi.length; i++) {
      incSales.push(this.state.tentpoleRoi[i].ADJ_Sales)
      incResponses.push(this.state.tentpoleRoi[i].ADJ_Resp)
      sales.push(this.state.tentpoleRoi[i].Sales)
      responses.push(this.state.tentpoleRoi[i].Responses)
      spend.push(this.state.tentpoleRoi[i].Cost)
      mailed.push(this.state.tentpoleRoi[i].Mailed)
    }

    const avgTicket = sales.reduce((a,b) => a + b, 0) / responses.reduce((a,b) => a + b, 0)
    const responseRate = responses.reduce((a,b) => a + b, 0) / mailed.reduce((a,b) => a + b, 0)

    return(
      <div>
        { this.state.isLoading ? <div className={classes.loader}><CircularProgress /></div> :
          this.state.tentpoleRoi.length > 0 ?
          <Fragment>
            <div align="center" style={{margin: "1em"}}>
              {console.log(this.state.tentpoleRoi)}
              <Typography style={{fontSize: '12px', color: "#fff"}} align="center">
                {/* Promotion: <span>New Years Synchrony Alignment OTB</span> */}
                On completed promotions, a total spend of <span style={this.props.darkMode ? {color: 'rgba(255, 115, 115, 0.7)'} : {color: 'rgba(255, 0, 0, 0.7)'}}>${Math.round(spend.reduce((a,b) => a + b, 0)).toLocaleString('en')}</span> has yielded <span style={{color: 'rgba(113, 177, 40)', fontWeight:'bold'}}>${Math.round(sales.reduce((a,b) => a + b, 0)).toLocaleString('en')}</span> in sales to responders (at a {(responseRate * 100).toFixed(2)}% response rate)
                {console.log(this.state.tentpoleRoi)}
              </Typography>
            </div>
            <div className={classes.data}>
              <div style={{ display: 'block', textAlign: 'left', marginLeft: '20px'}}>
                <div>
                  <h5 style={{opacity: 0.8, color: '#05b3ad'}}>AVG TICKET</h5>
                  <span className={this.props.darkMode ? classes.statsDark : classes.stats}>${Math.round(avgTicket).toLocaleString('en')}</span>
                </div>
                <hr className={classes.divider}/>
                <div>
                  <h5 style={{opacity: 1.0, color: '#529c00'}}>INC SALES</h5>
                  <span className={this.props.darkMode ? classes.statsDark : classes.stats}>${Math.round(incSales.reduce((a,b) => a + b, 0)).toLocaleString('en')}</span>
                </div>
                <hr className={classes.divider}/>
                <div >
                  <h5 style={this.props.darkMode ? {opacity: 0.8, color: '#faa2f4'} : {opacity: 0.8, color: '#942e92'}}>INC RESPONSES</h5>
                  <span className={this.props.darkMode ? classes.statsDark : classes.stats}>{Math.round(incResponses.reduce((a,b) => a + b, 0)).toLocaleString('en')}</span>
                </div>
              </div>
              <div className={classes.pie}>
                <DonutChart
                  labels={['Total Spend', 'Incremental Sales']}
                  data={[Math.round(spend.reduce((a,b) => a + b, 0)), Math.round(incSales.reduce((a,b) => a + b, 0))]}
                  colors={['rgba(235, 82, 82, 0.9)', 'rgba(110, 209, 0, 0.9)']}
                  radius={'70%'}
                  labelShow={true}
                  legend={true}
                  position={'bottom'}
                  height={250}
                  darkMode={this.props.darkMode}
                />
              </div>
            </div>
          </Fragment>
          : <AskReport home={true} />
        }
      </div>
    )
  }
}

export default withStyles(styles)(TentpoleMod)
